import { useState } from 'react';
import { Field, useFormikContext } from 'formik';

const ExpenseFlatFees = () => {
    const { values, setFieldValue } = useFormikContext();

    return (
        <>
        <div className='flex items-center my-5'>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            <p className='text-sm shrink-0 w-fit px-4'>Invoice & Items</p>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
        </div>
        <div className='flex items-start lg:flex-nowrap flex-wrap gap-5'>
            <div className=' w-full'>
                <div className="space-y-8">
                    <div className="flex items-center">
                        <span className="w-12 h-0.5 bg-border inline-block mr-2"></span>
                        <p className="text-sm">Expense Information</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {/* Invoice Number */}
                        <div>
                        <label className="form-label mb-1">Date Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.date_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_date">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Date</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.expenses.show_date", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Due Date */}
                        <div>
                        <label className="form-label mb-1">Quantity Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.quantity_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_quantity">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Quantity</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.expenses.show_quantity", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Issue Date */}
                        <div>
                        <label className="form-label mb-1">Price Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.price_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_price">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Price</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.expenses.show_price", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Invoice Title */}
                        <div>
                            <label className="form-label mb-1">Subtotal Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.expenses.subtotal_label" />
                        </div>

                        <div className="">
                        <label className="form-label mb-1">Billed By Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.billed_by_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_billed_by">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Billed By</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>
                        
                        <div className="">
                        <label className="form-label mb-1">Expense Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.expenses_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_expenses">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Expense</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_expenses", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        <div className="">
                        <label className="form-label mb-1">Description Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.description_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_description">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Description</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_description", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        <div className="">
                            <label className="form-label mb-1">Tax Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.expenses.tax_label" />
                        </div>

                        {/* <div className="">
                            <label className="form-label mb-1">Tax 2 Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.expenses.tax2_label" />
                        </div> */}

                        <div className="">
                        <label className="form-label mb-1">Total Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.expenses.total_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_total">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Total</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_total", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>
                    </div>
                    {/* <div className="">
                        <Field name="invoice_template_settings.expenses.use_initials_for_billed_by">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show billed by initials instead of full name?</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.use_initials_for_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.expenses.show_summary">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Summary</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_summary", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                    </div> */}
                </div>
                <div className="space-y-8">
                    <div className="flex items-center mt-8">
                        <span className="w-12 h-0.5 bg-border inline-block mr-2"></span>
                        <p className="text-sm">Flat Fees Information</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {/* Invoice Number */}
                        <div>
                        <label className="form-label mb-1">Date Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.date_label" />
                        {/* <Field name="invoice_template_settings.flat_fees.show_date">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Date</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.flat_fees.show_date", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Due Date */}
                        <div>
                        <label className="form-label mb-1">Quantity Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.quantity_label" />
                        {/* <Field name="invoice_template_settings.flat_fees.show_quantity">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Quantity</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.flat_fees.show_quantity", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Issue Date */}
                        <div>
                        <label className="form-label mb-1">Price Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.price_label" />
                        {/* <Field name="invoice_template_settings.flat_fees.show_price">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Price</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() => setFieldValue("invoice_template_settings.flat_fees.show_price", !field.value)}
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        {/* Invoice Title */}
                        <div>
                            <label className="form-label mb-1">Subtotal Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.flat_fees.subtotal_label" />
                        </div>

                        <div className="">
                        <label className="form-label mb-1">Billed By Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.billed_by_label" />
                        {/* <Field name="invoice_template_settings.flat_fees.show_billed_by">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Billed By</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.flat_fees.show_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        <div className="">
                        <label className="form-label mb-1">Flat Fees Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.flat_fees_label" />
                        {/* <Field name="invoice_template_settings.flat_fees.show_flat_fees">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Flat Fees</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.flat_fees.show_flat_fees", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        <div className="">
                        <label className="form-label mb-1">Description Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.description_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_description">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Description</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_description", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                        <div className="">
                            <label className="form-label mb-1">Tax Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.flat_fees.tax_label" />
                        </div>

                        {/* <div className="">
                            <label className="form-label mb-1">Tax 2 Label</label>
                            <Field className="input" type="text" name="invoice_template_settings.expenses.tax2_label" />
                        </div> */}

                        <div className="">
                        <label className="form-label mb-1">Total Label</label>
                        <Field className="input" type="text" name="invoice_template_settings.flat_fees.total_label" />
                        {/* <Field name="invoice_template_settings.expenses.show_total">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Total</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.expenses.show_total", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field> */}
                        </div>

                    </div>
                    {/* <div className="">
                        <Field name="invoice_template_settings.flat_fees.use_initials_for_billed_by">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show billed by initials instead of full name?</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.flat_fees.use_initials_for_billed_by", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.flat_fees.show_summary">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Summary</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.flat_fees.show_summary", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                        <Field name="invoice_template_settings.flat_fees.show_description">
                            {({ field, form }) => (
                            <label className="switch w-fit mt-2">
                                <span className="switch-label">Show Description</span>
                                <input
                                type="checkbox"
                                checked={field.value}
                                onChange={() =>
                                    setFieldValue("invoice_template_settings.flat_fees.show_description", !field.value)
                                }
                                />
                            </label>
                            )}
                        </Field>
                    </div> */}
                </div>
            </div>
        </div>
        </>
    )
}

export { ExpenseFlatFees }